import settingsStore from '../../services/settings/settings-store';

function join(host: string, path: string): string {
    if (host.length === 0) {
        return path;
    }
    if (path.length === 0) {
        return host;
    }
    const isLastSep = host[host.length - 1] === '/';
    const isFirstSep = path[0] === '/';
    if (isLastSep && isFirstSep) {
        return host.substring(0, host.length - 1) + path;
    } else if (!isLastSep && !isFirstSep) {
        return host + '/' + path;
    } else {
        return host + path;
    }
}

export const getSettingsSources = () => {
    const sources = {
        fetchSettings: '/settings/ajaxGetSettings',
        fetchPermissions: '/admin/ajax/permission',
        defaultSettings: '/assets/private-cameras/default.settings.json',
        customSettings: '/assets/private-cameras/settings.json'
    };
    /***************************************
***********************************************************
***************
*****************************************
************************
******************************************
**************************
**********************************************
*************************
*****************************************
********************
**************
*********
***********************************************************************
**************************************************************
*****
*****************************/
    return sources;
};
export const getVideoSources = () => {
    const sources = {
        singleUrl: '/camera/ajaxGetVideoUrls',
        multipleUrl: '/camera/ajaxGetVideoUrls',
        publicCameraUrl: '/publicLink/{extId}/getVideoUrls'
    };
    let host: string;
    /*********************************
***********************************************
********************************************************************************************
*****************************/
    /**********************************
***********************************************
******************************************************************
*****************************/

    return sources;
};
export const getPtzSources = () => {
    const sources = {
        getPosition: '/cameraManager/ajaxGetPosition',
        moveBase: '/cameraManager/ajaxMove'
    };
    /***************************************
************************************************
*****************************/
    return sources;
};
export const getPlayerVersion = () => {
    return '1.0.4';
};
export const getSwfPlayerBasePath = () => {
    const baseHost = settingsStore.getPublicPlayerHost();
    let path = join(baseHost, '/assets/private-cameras/lib/cctv-player/');
    /***************************************
*********************************************************************
***********************
*******************************************************
*****
*****************************/
    return path;
};
export const getSingleParamName = () => {
    let param = 'id';
    /***************************************
******************
*****************************/
    return param;
};
export const getPlayerName = () => {
    let name = 'publicPlayer';
    /*********************************
***********************
*****************************/
    /**********************************
**************************
*****************************/
    return name;
};
export const useAdmixture = () => {
    let value = false;
    /***************************************
*****************
*****************************/
    return value;
};
export const fetchPermission = () => {
    let value = true;
    /***************************************
******************
*****************************/
    return value;
};
export const useBeatManager = () => {
    let value = false;
    /*********************************
*****************
*****************************/
    return value;
};

/*******************************************/
// only for standalone page
document.title = settingsStore.getIntlMessage('js.public-player.window.title');
/************************/
